import {Box, Select, MenuItem, Grid, TextField, Typography} from "@mui/material";
import React from "react";

export function CrawlingInputConfig(props: any) {
    return (
            <Grid container item spacing={1}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextField
                    fullWidth
                    id='input_url'
                    label='Input URL : WEB Crawling URL'
                    value={props.input.url}
                    onChange={e => props.handleCrawlingInput(e)}
                    />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography>※ URL은 파라미터 없이 입력해주시면 됩니다, 파라미터는 PARAMS에서 입력해주세요</Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography>※ 데이터 수집은 입력한 URL에 대해서만 데이터를 수집합니다.</Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextField
                    fullWidth
                    id='input_query'
                    label='Input Area : WEB-Crawling Setting (예:/html/body/div[3]/main/section/div[2]/div[2]) '
                    value={props.input.query}
                    onChange={e => props.handleCrawlingInput(e)}
                    />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography>※ 해당 주소에서 저장할 영역의 “Full xPath“를 정의해주세요. 설정방법은 “설정 매뉴얼”을 참고해주세요.</Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Box sx={{
                                mt:1,
                                display:'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              height:'100%'}}>
                                    <Typography sx={{minWidth:120}}>
                                        페이지 유무
                                    </Typography>
                                    <TextField
                                        id='input_pagePath'
                                        label='Page Full xPath'
                                        value={props.input.pagePath}
                                        onChange={e => props.handleCrawlingInput(e)}
                                        sx={{ml:3}}>
                                    </TextField>
                                <Select
                                    id='input_pageType'
                                    value={props.input.pageType ?? 'attr'}
                                    sx={{ml:3, width:222}}
                                    onChange={e => props.handleInputPageType(e)}
                                >
                                    <MenuItem value="attr">attribute</MenuItem>
                                    <MenuItem value="text">text</MenuItem>
                                </Select>
                                    <TextField
                                        id='input_pageTypeName'
                                        label='Page Type Name'
                                        value={props.input.pageTypeName}
                                        onChange={e => props.handleCrawlingInput(e)}
                                        disabled={props.input.pageType !== 'attr'}
                                        sx={{ml:3}}>

                                    </TextField>
                            </Box>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box sx={{
                                    mt:1,
                                    display:'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  height:'100%'
                                }}>
                                    <Typography sx={{minWidth:120}}>
                                        상세페이지 유무
                                    </Typography>
                                    <TextField
                                        id='input_detailPath'
                                        label='Detail Page Full xPath'
                                        value={props.input.detailPath}
                                        onChange={e => props.handleCrawlingInput(e)}
                                        sx={{ml:3}}>
                                    </TextField>
                                      <TextField
                                        id='input_id'
                                        label='Input ID'
                                        value={props.input.id}
                                        onChange={e => props.handleCrawlingInput(e)}
                                        sx={{ml:3}}>
                                    </TextField>
                                    <TextField
                                        id='input_since'
                                        label='Input Since'
                                        value={props.input.since}
                                        onChange={e => props.handleCrawlingInput(e)}
                                        sx={{ml:3}}>
                                    </TextField>
                                </Box>
                </Grid>
            </Grid>
    )
}